<template>
  <div>
    <yjh-header :activeIndex="idnex"></yjh-header>
    <div class="index">
      <div class="navBox">
        <div class="w">
          <yjh-sNav :titleList="titleArr" @myFn="navRoute"></yjh-sNav>
        </div>
      </div>
      <yjh-jtjj v-if="navIndex == 0"></yjh-jtjj>
      <yjh-qywh v-if="navIndex == 1"></yjh-qywh>
      <yjh-fzlc v-if="navIndex == 2"></yjh-fzlc>
      <yjh-hzqy v-if="navIndex == 3"></yjh-hzqy>
      <yjh-footer></yjh-footer>
    </div>
    <!-- <yjh-menu></yjh-menu> -->
    <div class="index_mobile">
      <div class="index_mobile">
        <div
          class="nav_item"
          v-for="item in titleArr"
          @click="mobileNavClick(item.id)"
          :key="item.id"
        >
          <img :src="item.icon_active" alt="" v-if="item.id == mobileNavIndex" />
          <img :src="item.icon" alt="" v-else />

          <p class="nav_text" :class="{ active: item.id == mobileNavIndex }">
            {{ item.title }}
          </p>
        </div>
      </div>
      <yjh-jtjj v-if="mobileNavIndex == 0"></yjh-jtjj>
      <yjh-qywh v-if="mobileNavIndex == 1"></yjh-qywh>
      <yjh-fzlc v-if="mobileNavIndex == 2"></yjh-fzlc>
      <yjh-hzqy v-if="mobileNavIndex == 3"></yjh-hzqy>
      <yjh-footer></yjh-footer>
    </div>
  </div>
</template>

<script>
import footer from "@/layouts/footer";
import header from "@/layouts/header";
import menu from "@/layouts/menu";
import sNav from "@/layouts/sNav";
import jtjj from "./component/jtjj";
import qywh from "./component/qywh";
import fzlc from "./component/fzlc";
import hzqy from "./component/hzqy";
import src from "../../utils/assets";
import $ from "jquery";
export default {
  components: {
    "yjh-footer": footer,
    "yjh-header": header,
    "yjh-menu": menu,
    "yjh-sNav": sNav,
    "yjh-jtjj": jtjj,
    "yjh-qywh": qywh,
    "yjh-fzlc": fzlc,
    "yjh-hzqy": hzqy,
  },
  props: ["sNav", "header"],
  data() {
    return {
      idnex: "1",
      titleArr: [
        {
          id: 0,
          status: true,
          title: "公司简介",
          sTitle: "Group Introduction",
          icon: src.jianjie,
          icon_active: src.jianjie_active,
        },
        {
          id: 1,
          status: false,
          title: "企业文化",
          sTitle: "corporate culture",
          icon: src.wenhua,
          icon_active: src.wenhua_active,
        },
        {
          id: 2,
          status: false,
          title: "发展历程",
          sTitle: "development history",
          icon: src.licheng,
          icon_active: src.licheng_active,
        },
        {
          id: 3,
          status: false,
          title: "合作企业",
          sTitle: "cooperative enterprise",
          icon: src.hezuo,
          icon_active: src.hezuo_active,
        },
      ],
      navIndex: "0",
      mobileNavIndex: "0",
    };
  },
  created() {
    if (this.$route.query.navIndex == undefined) {
      this.navClick("0");
    } else {
      this.navClick(this.$route.query.navIndex);
    }
  },
  methods: {
    // 移动端
    mobileNavClick(id) {
      console.log(id);
      this.mobileNavIndex = id;
    },
    // 导航栏切换
    navClick(id) {
      this.navIndex = id;
      for (let i = 0; i < this.titleArr.length; i++) {
        this.titleArr[i].status = false;
      }
      this.titleArr[id].status = true;
    },
    // 导航栏路由
    navRoute(id) {
      this.$router.push({
        path: "/index",
        query: {
          navIndex: id,
        },
      });
      this.navClick(id);
    },
  },
};
</script>

<style lang="less">
.title {
  margin-top: 30px;
  font-size: 30px;
}
// 移动端
@media screen and (max-width: 999px) {
  .index {
    display: none;
  }
  .index_mobile {
    display: block;
    .index_mobile {
      display: flex;
      justify-content: space-around;
      .nav_item {
        text-align: center;
        margin: 10px 0;
      }
      img {
        width: 25px;
        height: 25px;
        margin-bottom: 5px;
      }
      .nav_text:focus {
        color: #da261d;
      }
      .active {
        color: #da261d;
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .index {
    display: block;
  }
  .index_mobile {
    display: none;
  }
}
</style>
